import { computed, ref } from 'vue';
import type { CellContentAlignment } from './form.types';
import { ALIGNMENT_ICON_MAP } from '../lib/cell-alignment';

interface UseCellAlignmentControlOptions {
  get: () => CellContentAlignment;
  set: (value: CellContentAlignment) => void;
}

/**
 * Shared alignment control for the table cell menus (cell-selection menu and
 * table toolbar). Only the read/write of the alignment value differs between
 * callers, so it is passed in via `get`/`set`; the open-state, current icon and
 * change handler are declared once here.
 */
export function useCellAlignmentControl({ get, set }: UseCellAlignmentControlOptions) {
  const alignmentOpen = ref(false);

  const alignment = computed<CellContentAlignment>({ get, set });

  const currentAlignmentIcon = computed(() => ALIGNMENT_ICON_MAP[alignment.value]);

  const handleAlignmentChange = (value: CellContentAlignment) => {
    alignment.value = value;
    alignmentOpen.value = false;
  };

  return { alignmentOpen, alignment, currentAlignmentIcon, handleAlignmentChange };
}
